// extracted by mini-css-extract-plugin
export default {"dates":"DatesTable_dates__HZy+6","shrink":"DatesTable_shrink__zJcDu"};